import { useEffect, useState } from "react";

// 전체화면 창 작업표시줄이 화면 상단과 하단 중 어디에 붙을지 정한다. 기본값은 상단이다.
export type WindowTaskbarPosition = "top" | "bottom";

const taskbarPositionStorageKey = "hatchery-registry:taskbar-position";

// 작업표시줄 도킹 위치를 브라우저에 저장해 새로고침/다음 방문에도 유지한다. theme 선호와 같은 패턴이다.
export function useWindowTaskbarPositionPreference(): readonly [
  WindowTaskbarPosition,
  (position: WindowTaskbarPosition) => void,
] {
  const [position, setPosition] = useState<WindowTaskbarPosition>(
    () => readStoredPosition() ?? "top",
  );

  useEffect(() => {
    try {
      window.localStorage.setItem(taskbarPositionStorageKey, position);
    } catch {
      // 사설 모드나 제한된 브라우저 환경에서는 Storage 를 쓸 수 없을 수 있다.
    }
  }, [position]);

  return [position, setPosition] as const;
}

function readStoredPosition(): WindowTaskbarPosition | null {
  try {
    const value = window.localStorage.getItem(taskbarPositionStorageKey);
    return value === "top" || value === "bottom" ? value : null;
  } catch {
    return null;
  }
}
